import * as angular from 'angular';
import { WideError } from '../../common';
import { ComponentDefinition } from '../../models';

class AlarmBadgeController implements angular.IComponentController {

    isLoading: boolean;

    readonly wideError: () => WideError;

    static $inject = ['$translate'];

    constructor(private _$translate: angular.translate.ITranslateService, ) {
    }

    message() {
        const err = this.wideError();
        const p: any[] = err.params;

        return err.message
            .split('\r\n')
            .map((line, i) => this._$translate.instant(line, p && p.length >= i ? p[i] : {}, null, null, null))
            .join('\r\n');
    }
}

export const wtAlarmBadge: ComponentDefinition = {
    componentId: 'wtAlarmBadge',
    controller: AlarmBadgeController,
    controllerAs: 'vm',
    template: require('./alarmBadge.component.html'),
    bindings: {
        wideError: '&',
        wideErrorMigrated: '<'
    }
};